export default "/media/logos/logo-sentia-icon.svg"